<script setup lang="ts">
import { type Ref, ref } from "vue";
import type { MenuResponse } from "../../responses/MenuResponse";

interface Props {
    menu: MenuResponse;
    currentRoute: string;
}

const props = withDefaults(defineProps<Props>(), {});
const openSubmenus: Ref<Array<number>> = ref([]);
const toggleMobileMenu: Ref<boolean> = ref(false);
const toggleSubmenu = (index) => {
    if (openSubmenus.value.includes(index)) {
        openSubmenus.value = openSubmenus.value.filter((i) => i !== index);
    } else {
        openSubmenus.value.push(index);
    }
};
</script>
<template>
    <div class="flex h-24 items-center justify-between">
        <div class="flex flex-1 lg:hidden">
            <button @click="toggleMobileMenu = true;" type="button" class="bg-white -ml-2 p-2 text-secondary-400 lg:hidden">
                <span class="sr-only">Open menu</span>
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        fill-rule="evenodd"
                        d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z"
                        clip-rule="evenodd"
                    />
                </svg>
            </button>
        </div>

        <div>
            <slot name="logo">

            </slot>
        </div>

        <slot name="menu">
        </slot>

        <div v-show="toggleMobileMenu" @click.prevent="toggleMobileMenu = false" class="fixed inset-0 bg-black/40 w-full z-40 lg:hidden"></div>

        <div id="mobileMenu" class="fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-all duration-300 ease-in-out"
             :class="toggleMobileMenu ? 'translate-x-0' : '-translate-x-full'">
            <div class="flex justify-between p-4">
                <span class="text-xl font-semibold">Menu</span>
                <button @click="toggleMobileMenu = !toggleMobileMenu;" class="text-xl">×</button>
            </div>
            <div class="px-4 py-4 space-y-4">
                <div v-for="(parentItem, index) in menu.items" :key="index">
                    <a :href="parentItem.slug"
                        v-if="parentItem.items" @click="toggleSubmenu(index)"
                        class="w-full text-left text-base font-medium text-secondary-700 hover:text-secondary-900">
                        {{ parentItem.label }}
                    </a>
                    <a v-else :href="parentItem.slug" class="block text-base font-medium text-secondary-700 hover:text-secondary-900">
                        {{ parentItem.label }}
                    </a>
                    <div v-if="parentItem.items" v-show="openSubmenus.includes(index)" class="ml-4 mt-2 space-y-2">
                        <a v-for="(child, cIndex) in parentItem.items" :key="cIndex" :href="child.slug"
                            class="block text-sm text-secondary-600 hover:text-secondary-900">
                            {{ child.label }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.sidebar-enter-active, .sidebar-leave-active {
    transition: transform 0.3s ease-in-out;
}
.sidebar-enter, .sidebar-leave-to {
    transform: translateX(-100%);
}
</style>
